import "./App.css";
import Header from "./components/Header";
import Display from "./components/Display";
import Footer from "./components/Footer";

function App() {
	return (
		<>
			<Header />
			<main>
				<Display />
			</main>
			<Footer />
		</>
	);
}

export default App;
